export const sidebar = {
  reduce: "Réduire",
  dashboard: "Tableau de bord",
  sale: "Vente",
  quote: "Devis",
  invoice: "Factures",
  credit_note: "Avoir",
  purchase: "Dépenses",
  purchase_expenses: "Dépenses d'achat",
  purchase_invoice: "Dépenses d'achat",
  client: "Client",
  clients: "Clients",
  offers: "Offres",
  suppliers: "Fournisseurs",
  config: "configuration",
  utilisateur: "Utilisateur",
  singaturelist: "Liste des signatures",
  projects: "Projets",
  absence: "Mes absences",
  mestemps: "Mes temps",
  requestLeave: "Demande de congé",
  validetcra: "Suivi des CRA ",

  // 📦 Packs
  pack: "Pack",
  pack_create: "Créer un pack",

  users: "Utilisateurs",
  role: "Rôles",

  // 💼 Vente

  expense: "Dépense",

  offer_create: "Créer une offre",

  // ✍️ Signature
  singature: "Signature",

  // 📄 Documents
  document: "Document",
  documents: "Documents",
};
